module.exports = __webpack_public_path__ + "static/img/059.3d8de13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/059.png
// module id = EdG7
// module chunks = 0